import { useTranslation } from "react-i18next"

/**
 * 微信内打开引导：在微信里无法直接下载 App / 唤起，需引导用户点右上角菜单在浏览器打开。
 * 仅在 isWechat() 为 true 时由页面决定是否展示。
 */
export interface WechatOpenGuideProps {
  open: boolean
  onClose?: () => void
}

export function WechatOpenGuide({ open, onClose }: WechatOpenGuideProps) {
  const { t } = useTranslation()
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/80"
      onClick={onClose}
      role="dialog"
      aria-label={t("common_open_in_browser")}
    >
      <div className="absolute right-4 top-3 text-right text-white">
        <div className="text-4xl leading-none">↗</div>
        <p className="mt-2 max-w-[180px] text-sm leading-relaxed">
          {t("common_open_in_browser")}
        </p>
      </div>
    </div>
  )
}
